import type { CSSProperties } from "react"

type MobileReversePackOrderStyle = (total?: number, index?: number) => CSSProperties

export const mobileReversePackOrderStyle: MobileReversePackOrderStyle = (total = 0, index = 0) =>
  ({
    "--mobile-pack-order": total - index,
  } as CSSProperties)
